import React from 'react';
import { Leaf, Activity, ShieldCheck } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const EssentialsNutritionPage = () => {
  const config = {
    badge: "Nutrition & Wellness",
    headline: "Nutrition &",
    headlineItalic: "Dietary Essentials.",
    subtext: "Evidence-based nutritional guidance from veterinary experts, helping your pet thrive with the right diet for their breed, age, and health status.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Pet Nutrition at Dr. Suresh Pet Care — Expert Dietary Counseling",
    stats: [
      { value: 5000, suffix: '+', label: 'Nutrition Plans' },
      { value: 30, suffix: '+', label: 'Prescription Diets' },
      { value: 85, suffix: '%', label: 'Body Condition Improvement' },
      { value: 24, suffix: '/7', label: 'Diet Support' },
    ],
    services: [
      {
        title: "Nutritional Assessment",
        icon: <Leaf size={28} />,
        desc: "Comprehensive body condition scoring and metabolic assessment to establish baseline nutritional needs.",
        specs: ["Body Condition Score", "Muscle Mass Index", "Weight History", "Metabolic Rate"],
        color: "from-green-500/10 to-primary/10"
      },
      {
        title: "Prescription Diets",
        icon: <Activity size={28} />,
        desc: "Medically indicated therapeutic diets for pets with kidney disease, diabetes, allergies, and obesity.",
        specs: ["Renal Diet", "Diabetic Formula", "Hydrolyzed Protein", "Joint Support Diet"],
        color: "from-primary/10 to-amber-500/10"
      },
      {
        title: "Supplement Guidance",
        icon: <ShieldCheck size={28} />,
        desc: "Evidence-based supplement recommendations for joint health, gut microbiome, skin, and cognitive function.",
        specs: ["Omega-3 Fatty Acids", "Joint Supplements", "Probiotics", "Cognitive Support"],
        color: "from-lime-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Nutrition",
    sectionItalic: "Programs.",
    warningTitle: "Nutritional",
    warningItalic: "Warning Signs.",
    warningText: "Poor nutrition is a leading cause of preventable disease in pets. These signs may indicate your pet's diet needs a veterinary review.",
    warnings: [
      { name: "Weight Gain", desc: "Obesity is the most common preventable health condition — affecting 55% of pets.", icon: "⚖️" },
      { name: "Dull Coat", desc: "A lackluster coat may indicate Omega-3 deficiency or nutrient malabsorption issues.", icon: "✨" },
      { name: "Low Energy", desc: "Persistent lethargy can be linked to inadequate protein or caloric intake.", icon: "😴" },
      { name: "GI Upsets", desc: "Frequent vomiting or diarrhea may indicate food intolerance or poor diet quality.", icon: "⚠️" },
    ],
    ctaBadge: "Nutrition Expert",
    ctaTitle: "The Nutrition",
    ctaItalic: "Expertise.",
    ctaText: "Our veterinary nutrition team creates personalized, science-backed dietary plans that support every stage of your pet's life and health journey.",
    ctaBtn: "Book Nutrition Consult",
    seoText: "Expert pet nutrition counseling in Hyderabad. Prescription diets and dietary supplements for dogs and cats at Dr. Suresh Pet Care.",
    glowColor: "green-500"
  };

  return (
    <>
      <SEO 
        title="Pet Nutrition & Dietary Essentials"
        description="Expert veterinary nutrition counseling and premium dietary guidance for dogs and cats at Dr. Suresh Pet Care, Hyderabad."
        canonical="/essentials-nutrition"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default EssentialsNutritionPage;
